/* eslint-disable @typescript-eslint/no-explicit-any */
import { deepCopy } from '../../helpers';

/**
 * Schema update from version 17 to version 18
 * - Adds persisted per-design skyKey ('sky/overcast') and floorKey ('floor/grid-tile') to all kitchens
 *   so the 3D sky/floor lock round-trips through save/serialize (GitHub #154/#204).
 */

export const u18 = (blueprint: any): any => {
	console.log('schema-update:process-update:18:started');

	try {
		const updatedBlueprint = deepCopy(blueprint);
		updatedBlueprint.schemaVersion = 18;

		if (updatedBlueprint.kitchens?.children) {
			updatedBlueprint.kitchens.children.forEach((kitchen: any) => {
				if (kitchen.skyKey === undefined) {
					kitchen.skyKey = 'sky/overcast';
				}
				if (kitchen.floorKey === undefined) {
					kitchen.floorKey = 'floor/grid-tile';
				}
			});
		}

		console.log('schema-update:process-update:18:completed');
		return updatedBlueprint;
	} catch (err) {
		console.error('schema-update:process-update:18:error', err);
		return null;
	}
};
